module.exports = __webpack_public_path__ + "img/Engie_80X30.3612d7f9.png";